import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ProductItemProductFragmentDoc } from './ProductItemProduct.generated'
import * as Types from './purchasePlus_graphql'

export const AddOrderInstructionLineModalLineFragmentDoc = gql`
  fragment AddOrderInstructionLineModalLine on RequisitionLine {
    id
    uuid
    orderInstruction
    supplier {
      id
      name
    }
    product {
      ...ProductItemProduct
      image
    }
  }
  ${ProductItemProductFragmentDoc}
` as unknown as DocumentNode<Types.AddOrderInstructionLineModalLineFragment, unknown>
